import React, { useState, useContext } from 'react';
import styled from 'styled-components/macro';
import MenuButton from '@components/controls/MenuButton/MenuButton';
import { UserContext } from '@stores/UserContext';
import PageTitle from '@components/layout/PageTitle';
import UserProfileMenu from './UserProfileMenu';
import { ThemeSwitcher } from '@components/menus/ThemeSwitcher';
import IconBugs from '@as_core/bugsReporting/bugs.icon';
import { BugsModal } from '@as_core/bugsReporting/bugs.modal';
import { CreditsContext } from '@stores/CreditsContext';

interface PropsT {
  title: string;
}

const debug = false;

const TopMenu = (props: PropsT) => {
  const { title } = props;
  const { user } = useContext(UserContext);
  const { creditsInfo } = useContext(CreditsContext);
  // check to see if signed
  debug &&
    console.log('UserProfileMenu | isAppAuthorized:', user?.isAppAuthorized);
  const [isBugsModalOpen, setIsBugsModalOpen] = useState(false);

  const handleBugs = () => {
    setIsBugsModalOpen((previous) => !previous);
    debug && console.log('handleBugs');
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <PageTitle title={title} />
        </HeaderLeft>
        <HeaderCenter>
          <CreditsContainer>
            <TotalCredits>{creditsInfo?.creditsAvailable}</TotalCredits>
            <CreditsLabel>
              <CreditsLabelLine color={'primary'}>Credits Available</CreditsLabelLine>
              <CreditsLabelLine>each submission costs 1 credit</CreditsLabelLine>
            </CreditsLabel>
          </CreditsContainer>
        </HeaderCenter>
        <HeaderRight>
          <ItemContainer>
            <ThemeSwitcher />
          </ItemContainer>
          {user?.isAppAuthorized ? (
            <ItemContainer>
              <MenuButton
                icon={<IconBugs size={24} />}
                onClick={handleBugs}
                isActive={isBugsModalOpen}
                spacing={'horizontal'}
                text={'Submit a Bug Report or Suggestion'}
                tooltipPlacement={'bottom-end'}
              />
            </ItemContainer>
          ) : (
            <></>
          )}
          <ItemContainer>
            <UserProfileMenu />
          </ItemContainer>
        </HeaderRight>
      </Header>
      <BugsModal
        modalOpen={isBugsModalOpen}
        setModalOpen={setIsBugsModalOpen}
      />
    </>
  );
};

export default TopMenu;

const Header = styled.div`
  display: grid;
  padding: 0;
  max-height: 50px;
  grid-auto-flow: column;
  grid-template-columns: min-content min-content;
  justify-content: space-between;
  height: max-content;
  width: 100%;
  margin-bottom: -1px;
  align-items: center;
  background-color: ${(p) => p.theme.palette.backgroundSecondary};
`;

const HeaderLeft = styled.div`
  min-width: 350px;
  display: grid;
  grid-auto-flow: column;
  justify-self: start;
  white-space: nowrap;
`;

const HeaderCenter = styled.div`
  min-width: 200px;
  display: flex;
  grid-auto-flow: column;
  justify-self: center;
  white-space: nowrap;
`;

const HeaderRight = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-self: end;
  padding-right: 20px;
`;

const ItemContainer = styled.div`
  height: 50px;
  padding: 0;
  margin: 0;
  width: max-content;
  align-items: center;
  display: grid;
`;

const CreditsContainer = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TotalCredits = styled.div`
  display: flex;
  padding-right: 5px;
  font-size: 28px;
`;

const CreditsLabel = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  justify-content: space-around;
`;

const CreditsLabelLine = styled.div<{color?: string}>`
  display: flex;
  align-items: center;
  font-style: italic;
  color: ${(p) => p.color === 'primary' ? 
          p.theme.palette.textPrimary : p.theme.palette.textSecondary};
  height: 15px;
`;
